export const thursdayUppercase = "nra";
export default {thursdayUppercase};